import type {Message, MinimalMessage} from '@/models/messageModel'
import type {Thread} from '@/models/threadModel'
import {createQueryConfig, NO_REFETCH_OPTIONS} from '@/utils/query/query'
import type {TextTopics} from '@/views/Chat/components/DefaultMessage/DefaultMessage'

export default createQueryConfig({
  messages: (threadId: Thread['id'] | undefined) => ({
    key: ['messages', threadId] as const,
    data: {} as (Message | MinimalMessage)[],
    options: {
      ...NO_REFETCH_OPTIONS,
    },
  }),
  threads: () => ({
    data: {} as Thread[],
  }),
  textTopicsWithCategory: () => ({
    data: {} as TextTopics,
    options: {
      ...NO_REFETCH_OPTIONS,
    },
  }),
})
